import React from 'react'
import { motion } from 'framer-motion'
import { Container } from 'react-bootstrap'
import useFetchData from '../../hooks/use-fetch-data'
import ScrollerIcon from '../scrollericon/ScrollerIcon';

function SkillsSection() {
    const { data } = useFetchData([]);
  return (
    <Container>
        <div className='skill-section'>
        {
            data.map(item => item.id == 7 ?
                (   
                    <>
                        <motion.div
                        initial={{ opacity: 0, y:50}}
                        whileInView={{ opacity: 1, y: 0, transition:{
                            duration: 0.5,
                            delay: 0.25
                        }}} 
                        className="header-title" dangerouslySetInnerHTML={{__html: item.acf.heading_title }} />
                        <div className='scroller-section'>
                            <ScrollerIcon />
                        </div>
                    </>
                    
                )
                : null
                
            )
        }
        </div>
    </Container>
  )
}

export default SkillsSection